import { usePassportProvider } from "@/context/PassportProvider";
import {
  LARGE_VERTICAL_BREAKPOINT,
  useIsLandscapeDisplayMode,
} from "@/hooks/useIsLandscapeDisplayMode";
import { Body, Checkbox, Stack } from "@biom3/react";
import { type ChangeEvent, useEffect, useState } from "react";

export const MarketingConsentStatusKey = "im_marketing_consent_status";
export enum MarketingConsentStatus {
  OptedIn = "opted_in",
  Unsubscribed = "unsubscribed",
  Subscribed = "subscribed",
}

type MarketingConsentProps = {
  variant?: "concise";
};

const MarketingConsent = ({ variant }: MarketingConsentProps) => {
  const isLandscapeDisplayMode = useIsLandscapeDisplayMode(
    LARGE_VERTICAL_BREAKPOINT,
  );
  const [pastLoginMarketingConsentStatus, setPastLoginMarketingConsentStatus] =
    useState<string | null>(null);

  useEffect(() => {
    setPastLoginMarketingConsentStatus(
      localStorage.getItem(MarketingConsentStatusKey),
    );
  }, []);

  const { marketingConsentStatus, setMarketingConsentStatus } =
    usePassportProvider();

  if (pastLoginMarketingConsentStatus) return null;

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    const status = isChecked
      ? MarketingConsentStatus.Unsubscribed
      : MarketingConsentStatus.OptedIn;

    setMarketingConsentStatus(status);
  };

  return (
    <Stack
      testId="marketing-consent"
      direction="row"
      gap="base.spacing.x2"
      sx={{
        pt: "base.spacing.x2",
        textAlign: "left",
      }}
      alignItems="center"
    >
      <Checkbox
        onChange={handleOnChange}
        id="marketingConsent"
        name="marketingConsent"
        checked={marketingConsentStatus === MarketingConsentStatus.Unsubscribed}
      />
      <Body
        size={isLandscapeDisplayMode ? "xxSmall" : "xSmall"}
        sx={{ color: "base.color.text.body.secondary" }}
      >
        <label htmlFor="marketingConsent">
          {variant === "concise"
            ? "Opt out of receiving emails from Immutable"
            : "I don't want to receive rewards, exclusive content, promos and more from Immutable"}
        </label>
      </Body>
    </Stack>
  );
};

export default MarketingConsent;
